import React, { FC } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import Item, { ItemProps } from "./Item"

const SortableItem: FC<ItemProps> = (props) => {
  const {
    id,
    children,
    animation,
  } = props

  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: id })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition: animation || transition || undefined,
  }

  return (
    <Item
      ref={setNodeRef}
      style={style}
      withOpacity={isDragging}
      {...props}
      {...attributes}
      {...listeners}
    >
      {children}
    </Item>
  )
}

export default SortableItem
